import './bootstrap'
import './validation'

// import Vuex settngs
import {store} from './store'

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

import { library } from '@fortawesome/fontawesome-svg-core';
// internal icons
import { faCheck, faCheckCircle, faInfoCircle, faExclamationTriangle, faExclamationCircle,
  faArrowUp, faAngleRight, faAngleLeft, faAngleDown,
  faEye, faEyeSlash, faCaretDown, faCaretUp, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faCheck, faCheckCircle, faInfoCircle, faExclamationTriangle, faExclamationCircle,
    faArrowUp, faAngleRight, faAngleLeft, faAngleDown,
    faEye, faEyeSlash, faCaretDown, faCaretUp, faUpload);
Vue.component('vue-fontawesome', FontAwesomeIcon);
//import buefy
import Buefy from 'buefy'

Vue.use(Buefy, {
  defaultIconComponent: 'vue-fontawesome',
  defaultIconPack: 'fas',
});

// Vue validation module
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

// VeeValidate module
import * as VeeValidate from 'vee-validate'
Vue.use(VeeValidate)


// lang.js
import Lang from 'lang.js';
//vue-lang
import VueLang from '@eli5/vue-lang-js'

import checkView from 'vue-check-view'
Vue.use(checkView)

const IS_DEV = true;

Vue.mixin({
  methods: {
    url: function (v = '') {
      return window.location.origin + v;
    },
    log: function (e = '') {
      if (IS_DEV) console.log(e);
    }
  },
  computed: {
    hasBlur: function () {
      return window.navigator.userAgent.toLowerCase().match(/(firefox)/) === null;
    },
  }
});

// init global vue app instance
document.addEventListener( "DOMContentLoaded", initVueApp);

function initVueApp(){

  /**
   * Inizializzazione modulo traduzioni
   */
  const default_locale = window.default_locale;
  const fallback_locale = window.fallback_locale;
  const translations = require('../lang/export.js').default;

  Vue.prototype.trans = new Lang({
    messages: translations,
    default: default_locale,
    fallback: fallback_locale
  });
  Vue.use(VueLang, {
    messages: translations, // Provide locale file
    locale: default_locale, // Set locale
    fallback: fallback_locale // Set fallback lacale
  })

  /**
   * Debug lista traduzioni in console
   */
  // console.log( 'Lista traduzioni caricate >>>' );
  // console.log(Vue.prototype.trans);


  /**
   * Inizializzazione istanza vue principale
   */
  const app = new Vue({

    el: '#app',
    store,

    computed: {

      nav: function(){
        return this.$store.state.nav;
      },

      /**
       * loading del contenuto
       */
      loading: function(){
        return !this.$store.state.nav;
      },

      /**
       * loading di tipo "layer"
       */
      layer_loading(){
        return this.$store.state.app_loading;
      },

      contenuti_pagine: function(){
        return this.$store.state.contenuti_pagine;
      }

    },

    beforeCreate: function(){

      // get navigation data
       this.$store.dispatch('get_navigation_data');
       //get contenuti pagine
       this.$store.dispatch('get_contenuti_pagine');

       // load language to store
       this.$store.commit('set_current_lang', this.trans.getLocale());

    },

    mounted: function(){

      // console.log('Istanza vue pronta per il broadcasting...');

      // start broadcasting service
      // Echo.channel('NotificationChannel')
      //   .listen('.NewNotificationEvent', (e) => {

      //     this.$store.commit('add_message', {
      //       type: 'info',
      //       message: e.message
      //     })

      //   })

    }

  })

}
